import { memo } from 'react';
import { interpolate, useAnimatedStyle } from 'react-native-reanimated';
import { Box, Image, Text } from '@bonanza-social/moonlight';
import { ARROW_STYLE } from './PrizeWallQuickRule.content';
import { PrizeWallQuickRuleProps } from './PrizeWallQuickRule.types';
import PrizeWallImage from '../../common/PrizeWallImage/PrizeWallImage';

function PrizeWallQuickRule({
  index,
  title,
  image,
  arrow,
  animatedValue,
}: PrizeWallQuickRuleProps) {
  const imageAnimatedStyle = useAnimatedStyle(() => ({
    opacity: interpolate(animatedValue.value, [index - 1, index - 0.5], [0, 1]),
  }));
  const arrowAnimatedStyle = useAnimatedStyle(() => ({
    opacity: interpolate(animatedValue.value, [index - 0.5, index], [0, 1]),
  }));

  return (
    <Box flex={1} width="100%">
      <Box animatedStyle={imageAnimatedStyle}>
        <PrizeWallImage {...image} height={80} />
        <Text
          variant="h5"
          paddingHorizontal="space-1600"
          textAlign="center"
          color="darkSurfacePrimary"
          paddingTop="space-200"
        >
          {title}
        </Text>
      </Box>
      {arrow && (
        <Box animatedStyle={arrowAnimatedStyle}>
          <Image
            name={`prizeWall.${arrow}`}
            position="absolute"
            bottom="space-0"
            {...ARROW_STYLE[arrow]}
          />
        </Box>
      )}
    </Box>
  );
}

export default memo(PrizeWallQuickRule);
